import { render, staticRenderFns } from "./moneyLayer.vue?vue&type=template&id=1f48a5c3&scoped=true&"
import script from "./moneyLayer.vue?vue&type=script&lang=js&"
export * from "./moneyLayer.vue?vue&type=script&lang=js&"
import style0 from "./moneyLayer.vue?vue&type=style&index=0&id=1f48a5c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48a5c3",
  null
  
)

export default component.exports